import http from "app/services/httpService";
import config from "config.json";

const { apiUrl } = config;

const getTransactionHistoryById = async (id, query) => {
  const data = await http.get(
    `${apiUrl}/members/transaction-history-all/${id}${query ? `?${query}` : ""}`
  );
  return data;
};

const getManualDrCrHistoryById = async (memId, query) => {
  const data = await http.get(
    `${apiUrl}/members/debit-credit-list/${memId}${query ? `?${query}` : ""}`
  );
  return data;
};

const getTransactionHistory = async (query) => {
  const data = await http.get(
    `${apiUrl}/members/transaction-history${query ? `?${query}` : ""}`
  );
  return data;
};
const getTransactionLogAll = async (query) => {
  const data = await http.get(
    `${apiUrl}/supplier-transaction/transaction-history${
      query ? `?${query}` : ""
    }`
  );
  return data;
};

const exportLedger = async (queryString) => {
  try {
    const url = `${apiUrl}/supplier-transaction/transaction-history/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await http.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

const exportTransaction = async (queryString) => {
  try {
    const url = `${apiUrl}/members/transaction-history-all/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await http.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

export {
  getTransactionHistoryById,
  getManualDrCrHistoryById,
  getTransactionHistory,
  exportTransaction,
  exportLedger,
  getTransactionLogAll,
};
